"use strict";

/**
 * @classdesc
 * Wechselt die Ansicht des WebClienten zwischen Vollbild und normaler Ansicht.
 *
 * @class
 * @extends gc.gis.action.GCAbstractAction
 * @memberof gc.gis.action
 * @author Anton Popov <a.popov@brain-scc.de>
 *
 * @param {Object} options Aufrufoptionen
 */
gc.gis.action.GCToggleFullscreen = function(options)
{
    gc.gis.action.GCAbstractAction.call(this);

    this.func = this.doExecute;
    this.args = [];
};
gc.gis.action.GCToggleFullscreen.prototype = Object.create(gc.gis.action.GCAbstractAction.prototype);

/**
 * Schaltet die Vollbildansicht an, wenn aus bzw. aus, wenn an.
 */
gc.gis.action.GCToggleFullscreen.prototype.doExecute = function()
{
    gc.gis.iface.ui.toggleFullscreen();
};
